import React from "react";

const WORDS = [
  "Small batch",
  "Cold pressed",
  "Slow steeped",
  "Fresh",
  "Rooted in nature",
  "Crafted with care",
];

export default function EditorialMarquee() {
  const track = [...WORDS, ...WORDS, ...WORDS];
  return (
    <section
      data-testid="marquee"
      className="bg-[color:var(--sr-primary)] text-[color:var(--sr-secondary)] py-8 md:py-12 border-y hairline-light overflow-hidden"
    >
      <div className="flex whitespace-nowrap marquee-track">
        {track.map((w, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span className="font-serif italic text-5xl md:text-7xl leading-none px-8 md:px-14">
              {w}
            </span>
            <span
              className="inline-block w-2.5 h-2.5 rounded-full bg-[color:var(--sr-accent)] shrink-0"
              aria-hidden="true"
            />
          </span>
        ))}
      </div>
    </section>
  );
}
